import { handleLocalStorage } from '@utils';
import { LocalStorageType } from '@utils/types';

const HANDOFF_STORAGE_KEY = 'forethought_handoff_state' as const;
const HANDOFF_EXPIRY_MS = 3 * 60 * 60 * 1000; // 3 hours in milliseconds
const { setItem, getItem, removeItem } = handleLocalStorage;

const setHandoffActive = (count = 0) => {
  setItem(HANDOFF_STORAGE_KEY, { unreadMessages: count, expiry: Date.now() + HANDOFF_EXPIRY_MS });
};

const getHandoffState = (): LocalStorageType[typeof HANDOFF_STORAGE_KEY] | null => {
  const handoffState = getItem(HANDOFF_STORAGE_KEY);
  if (handoffState && Date.now() > handoffState.expiry && handoffState.unreadMessages === 0) {
    removeItem(HANDOFF_STORAGE_KEY);
    return null;
  }
  return handoffState ?? null;
};

export const handoffState = {
  setHandoffActive,
  getHandoffState,
};
